{
  "SET_NEW_PASSWORD": {
    "TITLE": "Estableix la nova contrasenya",
    "PASSWORD": {
      "LABEL": "Contrasenya",
      "PLACEHOLDER": "Contrasenya",
      "ERROR": "La contrasenya és massa curta."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirma la contrasenya",
      "PLACEHOLDER": "Confirma la contrasenya",
      "ERROR": "La contrasenya no coindeix."
    },
    "API": {
      "SUCCESS_MESSAGE": "S'ha canviat la contrasenya correctament.",
      "ERROR_MESSAGE": "No s'ha pogut connectar amb el servidor Woot. Torna-ho a provar més endavant"
    },
    "CAPTCHA": {
      "ERROR": "La verificació ha caducat. Si us plau, torna a resoldre captcha."
    },
    "SUBMIT": "Envia"
  }
}
